<template>
  <FullPageLayout>
    <ErrorPageLayout :error="error" />
  </FullPageLayout>
</template>

<script>
import FullPageLayout from '@/modules/common/components/layout/FullPageLayout';
import ErrorPageLayout from '@/modules/common/components/layout/ErrorPageLayout.vue';
export default {
  components: { FullPageLayout, ErrorPageLayout },
  props: ['error'],
  layout: 'error', // you can set a custom layout for the error page
};
</script>
